module.exports = __webpack_public_path__ + "static/media/edy.faf8072b.jpg";